import { StoreState } from "./index";

export function getShareCount(state: StoreState): StoreState["shareCount"] {
  return state.shareCount;
}

export function getIsLoadingShareCount(
  state: StoreState
): StoreState["isLoadingShareCount"] {
  return state.isLoadingShareCount;
}
